var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.visibleTipsModal ? _c("a-modal", {
    attrs: {
      title: _vm.$t("提示"),
      "ok-text": _vm.$t("立即重置"),
      "cancel-text": _vm.$t("取消"),
      maskClosable: false,
      destroyOnClose: true
    },
    on: {
      ok: _vm.confirmTipsModal,
      cancel: _vm.cancleTipsModal
    },
    model: {
      value: _vm.visibleTipsModal,
      callback: function ($$v) {
        _vm.visibleTipsModal = $$v;
      },
      expression: "visibleTipsModal"
    }
  }, [_c("div", {
    staticClass: "safeContent"
  }, [_c("span", [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "exclamation-circle"
    }
  })], 1), _c("div", {
    staticClass: "safeTips"
  }, [_c("div", {
    staticClass: "safeTip"
  }, [_vm._v(" " + _vm._s(_vm.$t("您目前密码安全性较低，为保证账号的安全，建议重置密码。")) + " ")]), _c("a-checkbox", {
    on: {
      change: _vm.checkboxChange
    },
    model: {
      value: _vm.isTip,
      callback: function ($$v) {
        _vm.isTip = $$v;
      },
      expression: "isTip"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("7天之内不再提示")) + " ")])], 1)])]) : _vm._e(), _c("editPasswordModal", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visibleEditModal,
      expression: "visibleEditModal"
    }],
    attrs: {
      visible: _vm.visibleEditModal
    },
    on: {
      "update:visible": function ($event) {
        _vm.visibleEditModal = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };